module.exports = __webpack_public_path__ + "img/icon_features_3.68c89d00.png";